import { unsafeCSS, html } from "lit";
import { ifDefined } from "lit/directives/if-defined.js";
import { property, query } from "lit/decorators.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../leaf-element.js";
import { LeafIcon } from "../icon/icon.component.js";
const styles = `@charset "UTF-8";
/*------------------------------------*\\
#BREADCRUMBS-ITEM
\\*------------------------------------*/
/*------------------------------------*\\
    #RESET
\\*------------------------------------*/
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

[hidden] {
  display: none !important;
}

/* ------------------------------------*\\
    #TYPOGRAPHY PLACEHOLDERS
\\*------------------------------------ */
.leaf-c-breadcrumbs__link {
  border-bottom: none !important;
}

/*
  Hiding class, making content visible only to screen readers but not visually ("sr" meaning "screen-reader")
  Is the hidden content read by a screen reader?	- Yes
  Will the hidden element affect the document layout? - No
  Will the hidden element’s box model be rendered? - No
  Does the element detect clicks or focus? - Yes
  https://css-tricks.com/comparing-various-ways-to-hide-things-in-css/#method-5-the-visually-hidden-class
*/
@media (max-width: 47.999rem) {
  :host([mobile-breadcrumb]) {
    display: flex;
  }
  :host([mobile-breadcrumb]) .leaf-c-breadcrumbs__link {
    order: 2;
  }
  :host([mobile-breadcrumb]) .leaf-c-breadcrumbs__link:hover {
    color: var(--leaf-color-content-link-hover);
  }
  :host([mobile-breadcrumb]) .leaf-c-breadcrumbs__link:hover + leaf-icon {
    --icon-fill: var(--leaf-color-content-link-hover);
  }
  :host([mobile-breadcrumb]) .leaf-c-breadcrumbs__link:focus {
    background: var(--leaf-base-color-neutral-100);
    color: var(--leaf-color-content-knockout);
    outline: none;
  }
  :host([mobile-breadcrumb]) .leaf-c-breadcrumbs__link:focus + leaf-icon {
    --icon-fill: var(--leaf-color-content-knockout);
    background: var(--leaf-base-color-neutral-100);
  }
  :host([mobile-breadcrumb]) leaf-icon {
    --icon-fill: var(--leaf-color-content-link);
    --icon-height: var(--leaf-spacing-24);
    --icon-width: var(--leaf-spacing-24);
    margin: 0;
    transform: rotate(180deg);
  }
}

/**
 * 1) Singular item within the breadcrumbs component that contains a link elsewhere on the site
 */
.leaf-c-breadcrumbs__item {
  font-family: var(--leaf-typography-body-default-font-family);
  font-size: var(--leaf-typography-body-default-font-size);
  font-weight: var(--leaf-typography-body-default-font-weight);
  line-height: var(--leaf-typography-body-default-line-height);
  -webkit-text-decoration: var(--leaf-typography-body-default-text-decoration);
          text-decoration: var(--leaf-typography-body-default-text-decoration);
  text-transform: var(--leaf-typography-body-default-text-transform);
  align-items: center;
  display: inline-flex;
  height: var(--leaf-spacing-24);
  /**
  * Breadcrumbs item within the last leaf-breadcrumbs-item wrapper
  * 1) Change the treatment to not represent a link
  */
}
:host(:last-child) .leaf-c-breadcrumbs__item {
  color: var(--leaf-color-content-default);
}

/**
* Breadcrumbs link
*/
.leaf-c-breadcrumbs__link {
  font-family: var(--leaf-typography-body-default-link-font-family);
  font-size: inherit;
  font-weight: var(--leaf-typography-body-default-link-font-weight);
  line-height: inherit;
  -webkit-text-decoration: var(--leaf-text-decoration-none);
          text-decoration: var(--leaf-text-decoration-none);
  text-transform: var(--leaf-typography-body-default-link-text-transform);
  border-bottom: var(--leaf-border-width-default) solid;
  color: var(--leaf-color-content-link);
  word-break: break-word;
  align-items: center;
  display: flex;
  height: inherit;
}
.leaf-c-breadcrumbs__link:hover {
  color: var(--leaf-color-content-link-hover);
}
.leaf-c-breadcrumbs__link:focus {
  background-color: var(--leaf-color-bg-active);
  border-color: var(--leaf-color-border-transparent);
  color: var(--leaf-color-content-knockout);
  outline: none;
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--external)::after {
  background-color: currentColor;
  content: ".";
  margin: 0 0 0 var(--leaf-spacing-4);
  padding: 0 calc(var(--leaf-spacing-8) - var(--leaf-spacing-2));
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='none'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cpath xmlns='http://www.w3.org/2000/svg' id='svg_1' fill='%23333333' d='m28.667,28.667l-9.334,0l0,-9.334l4.667,0l0,-1.333l-4.667,0c-0.74,0 -1.333,0.6 -1.333,1.333l0,9.334c0,0.733 0.593,1.333 1.333,1.333l9.334,0c0.733,0 1.333,-0.6 1.333,-1.333l0,-4.667l-1.333,0l0,4.667zm-3.334,-10.667l0,1.333l2.394,0l-6.554,6.554l0.94,0.94l6.554,-6.554l0,2.394l1.333,0l0,-4.667l-4.667,0z'/%3E%3C/g%3E%3C/svg%3E");
          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='none'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cpath xmlns='http://www.w3.org/2000/svg' id='svg_1' fill='%23333333' d='m28.667,28.667l-9.334,0l0,-9.334l4.667,0l0,-1.333l-4.667,0c-0.74,0 -1.333,0.6 -1.333,1.333l0,9.334c0,0.733 0.593,1.333 1.333,1.333l9.334,0c0.733,0 1.333,-0.6 1.333,-1.333l0,-4.667l-1.333,0l0,4.667zm-3.334,-10.667l0,1.333l2.394,0l-6.554,6.554l0.94,0.94l6.554,-6.554l0,2.394l1.333,0l0,-4.667l-4.667,0z'/%3E%3C/g%3E%3C/svg%3E");
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--lock)::after {
  background-color: currentColor;
  content: ".";
  margin: 0 0 0 var(--leaf-spacing-8);
  padding: 0 calc(var(--leaf-spacing-8) - var(--leaf-spacing-2));
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='none'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cpath xmlns='http://www.w3.org/2000/svg' d='m28.5,21.25l-0.75,0l0,-1.571c0,-2.169 -1.68,-3.929 -3.75,-3.929c-2.07,0 -3.75,1.76 -3.75,3.929l0,1.571l-0.75,0c-0.825,0 -1.5,0.707 -1.5,1.571l0,7.858c0,0.864 0.675,1.571 1.5,1.571l9,0c0.825,0 1.5,-0.707 1.5,-1.571l0,-7.859c0,-0.864 -0.675,-1.571 -1.5,-1.571l0,0.001zm-6.75,-1.571c0,-1.305 1.005,-2.358 2.25,-2.358s2.25,1.053 2.25,2.358l0,1.571l-4.5,0l0,-1.571zm6.75,11l-9,0l0,-7.859l9,0l0,7.858l0,0.001zm-4.5,-2.359c0.825,0 1.5,-0.707 1.5,-1.571s-0.675,-1.571 -1.5,-1.571s-1.5,0.707 -1.5,1.571s0.675,1.571 1.5,1.571z' fill='%23333333' id='svg_1'/%3E%3C/g%3E%3C/svg%3E");
          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='none'%3E%3Cg%3E%3Ctitle%3ELayer 1%3C/title%3E%3Cpath xmlns='http://www.w3.org/2000/svg' d='m28.5,21.25l-0.75,0l0,-1.571c0,-2.169 -1.68,-3.929 -3.75,-3.929c-2.07,0 -3.75,1.76 -3.75,3.929l0,1.571l-0.75,0c-0.825,0 -1.5,0.707 -1.5,1.571l0,7.858c0,0.864 0.675,1.571 1.5,1.571l9,0c0.825,0 1.5,-0.707 1.5,-1.571l0,-7.859c0,-0.864 -0.675,-1.571 -1.5,-1.571l0,0.001zm-6.75,-1.571c0,-1.305 1.005,-2.358 2.25,-2.358s2.25,1.053 2.25,2.358l0,1.571l-4.5,0l0,-1.571zm6.75,11l-9,0l0,-7.859l9,0l0,7.858l0,0.001zm-4.5,-2.359c0.825,0 1.5,-0.707 1.5,-1.571s-0.675,-1.571 -1.5,-1.571s-1.5,0.707 -1.5,1.571s0.675,1.571 1.5,1.571z' fill='%23333333' id='svg_1'/%3E%3C/g%3E%3C/svg%3E");
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: var(--leaf-spacing-40);
          mask-size: var(--leaf-spacing-40);
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--inverted) {
  color: var(--leaf-color-content-knockout);
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--inverted):hover {
  color: var(--leaf-color-content-brand-knockout);
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--inverted):focus {
  background-color: var(--leaf-color-content-knockout);
  color: var(--leaf-color-bg-active);
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action) {
  border-bottom: none;
  display: inline-block;
  line-height: var(--leaf-spacing-32);
  margin: var(--leaf-spacing-8) calc(var(--leaf-spacing-48) - var(--leaf-spacing-4));
  margin-left: 0;
  position: relative;
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action)::before {
  content: "";
  display: inline-block;
  height: 100%;
  min-height: var(--leaf-spacing-40);
  vertical-align: middle;
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action)::after {
  background-color: currentColor;
  bottom: 0;
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='white'/%3E%3C/svg%3E");
  height: var(--leaf-spacing-40);
  margin-left: var(--leaf-spacing-4);
  position: absolute;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='%23001F99'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='white'/%3E%3Crect x='39' y='39' width='38' height='38' rx='19' transform='rotate(180 39 39)' stroke='transparent' stroke-width='2'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='%23001F99' stroke-width='2'/%3E%3C/svg%3E");
          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='%23001F99'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='white'/%3E%3Crect x='39' y='39' width='38' height='38' rx='19' transform='rotate(180 39 39)' stroke='transparent' stroke-width='2'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='%23001F99' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  width: var(--leaf-spacing-40);
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action):focus:after {
  border-radius: 50%;
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5.28027' y='5' width='30' height='30' rx='15' fill='%23001F99'/%3E%3Cpath d='M20.2803 12L18.8703 13.41L24.4503 19H12.2803V21H24.4503L18.8703 26.59L20.2803 28L28.2803 20L20.2803 12Z' fill='white'/%3E%3Crect x='39.2803' y='39' width='38' height='38' rx='19' transform='rotate(180 39.2803 39)' stroke='black' stroke-width='2'/%3E%3Crect x='5.28027' y='5' width='30' height='30' rx='15' stroke='%23001F99' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask: none;
          mask: none;
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action):where(.leaf-u-link--inverted)::after {
  border-radius: 50%;
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3C/svg%3E");
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='white'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='white' stroke-width='2'/%3E%3C/svg%3E");
          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='white'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='white' stroke-width='2'/%3E%3C/svg%3E");
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action):where(.leaf-u-link--inverted):hover::after {
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='%23E6EBFF'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3Crect x='39' y='39' width='38' height='38' rx='19' transform='rotate(180 39 39)' stroke='transparent' stroke-width='2'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='%23E6EBFF' stroke-width='2'/%3E%3C/svg%3E");
          mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='%23E6EBFF'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3Crect x='39' y='39' width='38' height='38' rx='19' transform='rotate(180 39 39)' stroke='transparent' stroke-width='2'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='%23E6EBFF' stroke-width='2'/%3E%3C/svg%3E");
}
.leaf-c-breadcrumbs__link:where(.leaf-u-link--action):where(.leaf-u-link--inverted):focus:after {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 41 40' fill='none'%3E%3Crect x='5' y='5' width='30' height='30' rx='15' fill='%23E6EBFF'/%3E%3Cpath d='M20 12L18.59 13.41L24.17 19H12V21H24.17L18.59 26.59L20 28L28 20L20 12Z' fill='%230033FF'/%3E%3Crect x='39' y='39' width='38' height='38' rx='19' transform='rotate(180 39 39)' stroke='white' stroke-width='2'/%3E%3Crect x='5' y='5' width='30' height='30' rx='15' stroke='%23E6EBFF' stroke-width='2'/%3E%3C/svg%3E");
  -webkit-mask: none;
          mask: none;
}

/**
* Breadcrumbs icon
*/
leaf-icon {
  --icon-fill: var(--leaf-base-color-neutral-80);
  margin: 0 var(--leaf-base-spacing-8);
}`;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _LeafBreadcrumbsItem = class _LeafBreadcrumbsItem extends e(LeafElement) {
  get breadcrumbSlottedText() {
    var _a;
    return (_a = this.textContent) == null ? void 0 : _a.trim();
  }
  async updated() {
    await this.updateComplete;
    if (this.breadcrumbSlottedText && this.breadcrumbLink) {
      this.breadcrumbLink.setAttribute("data-element-text", this.breadcrumbSlottedText);
    }
  }
  render() {
    return html`
      <div class="leaf-c-breadcrumbs__item" role="listitem">
        ${this.href ? html`<a class="leaf-c-breadcrumbs__link" href=${ifDefined(this.href)} target=${ifDefined(this.target)}>
                <slot></slot>
              </a>
              <leaf-icon name="keyboard-arrow-right" set="system"></leaf-icon>` : html`<slot></slot>`}
      </div>
    `;
  }
};
_LeafBreadcrumbsItem.styles = unsafeCSS(styles);
_LeafBreadcrumbsItem.elementDefinitions = {
  "leaf-icon": LeafIcon
};
let LeafBreadcrumbsItem = _LeafBreadcrumbsItem;
__decorateClass([
  property()
], LeafBreadcrumbsItem.prototype, "href", 2);
__decorateClass([
  property()
], LeafBreadcrumbsItem.prototype, "target", 2);
__decorateClass([
  query(".leaf-c-breadcrumbs__link")
], LeafBreadcrumbsItem.prototype, "breadcrumbLink", 2);
export {
  LeafBreadcrumbsItem
};
//# sourceMappingURL=breadcrumbs-item.component.js.map
